"use client";

import React from "react";
const complianceLogos = [{
  name: "SEC REGULATED",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_sec_compliance.png"
}, {
  name: "AES-256 ENCRYPTION",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_aes_encryption.png"
}, {
  name: "SIPC PROTECTED",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_sipc_compliance.png"
}, {
  name: "FINRA MEMBER",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_finra_compliance.png"
}, {
  name: "2FA MANDATORY",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_2fa_security.png"
}, {
  name: "COLD STORAGE",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_cold_storage.png"
}, {
  name: "ISO 27001 CERTIFIED",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604002/img/logo_iso27001_compliance.png"
}];
export default function GlobalTrustNetwork() {
  return <section data-section-id="72032" id="institutional-grade-security" className="dark bg-background text-foreground">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        .pause-on-hover:hover .animate-marquee {
          animation-play-state: paused;
        }
      `}</style>

      <div className="bg-card/20 border-y border-muted/10 py-8 overflow-hidden flex flex-col items-center relative">
        {}
        <div className="absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-background/90 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-background/90 to-transparent z-10 pointer-events-none"></div>

        <h2 className="text-center text-[11px] font-mono font-bold uppercase tracking-[0.3em] text-muted-foreground mb-8 px-4 z-20">
          Institutional Grade Security Protocols
        </h2>

        <div className="relative flex w-full overflow-hidden pause-on-hover z-0">
          {}
          <div className="animate-marquee flex min-w-full shrink-0 items-center justify-around gap-12 px-6 sm:gap-20 sm:px-10">
            {complianceLogos.map((logo, i) => <div key={`track1-${i}`} data-index={i} className="flex items-center justify-center min-w-[140px]">
                <img src={logo.src} alt={logo.name} className="h-7 sm:h-9 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer drop-shadow-[0_0_8px_rgba(6,182,212,0.25)]" />
              </div>)}
          </div>

          {}
          <div aria-hidden="true" className="animate-marquee flex min-w-full shrink-0 items-center justify-around gap-12 px-6 sm:gap-20 sm:px-10">
            {complianceLogos.map((logo, i) => <div key={`track2-${i}`} data-index={i} className="flex items-center justify-center min-w-[140px]">
                <img src={logo.src} alt={logo.name} className="h-7 sm:h-9 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer drop-shadow-[0_0_8px_rgba(6,182,212,0.25)]" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}